<div class="localization-table-container">
  <div class="table-header">
    <h2>{{ tableTitle }} - Localization Table</h2>
    <div class="table-header-actions">
      <p-button
        *ngIf="selectedRecords.length > 0"
        [label]="'Translate selected (' + selectedRecords.length + ')'"
        styleClass="p-button-sm p-button-info"
        icon="pi pi-language"
        type="button"
        (click)="bulkTranslateSelected()"
        [loading]="bulkLocalizeInProgress || webadminTranslateInProgress"
        [disabled]="bulkLocalizeInProgress || webadminTranslateInProgress">
      </p-button>
      <p-button
        label="Actions"
        styleClass="p-button-sm"
        icon="pi pi-cog"
        type="button"
        (click)="actionsDialogVisible = true">
      </p-button>
    </div>
  </div>
  
  <p-dialog 
    [(visible)]="actionsDialogVisible" 
    header="Table Actions" 
    [modal]="true" 
    [draggable]="true" 
    [resizable]="true"
    [style]="{ width: '50vw' }"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    (onShow)="onActionsDialogShow()">
    <div class="actions-content">
      <p-panel header="Export">
        <p-button 
          label="Export to CSV" 
          icon="pi pi-download" 
          styleClass="p-button-sm p-mr-2"
          (click)="exportToCSV()">
        </p-button>
      </p-panel>
      
      <p-panel header="Table Operations" class="p-mt-3">
        <p-button 
          label="Refresh Data" 
          icon="pi pi-refresh" 
          styleClass="p-button-sm p-mr-2"
          (click)="refreshData()">
        </p-button>
        <p-button 
          label="Clear Filters" 
          icon="pi pi-filter-slash" 
          styleClass="p-button-sm p-mr-2"
          (click)="clearFilters()">
        </p-button>
      </p-panel>

      <p-panel *ngIf="isMigrateFromGridlyTable" header="Migrate from Gridly (It's temporary and will be removed in the future)" class="p-mt-3">
        <div class="bulk-localize-form">
          <div class="p-message p-message-info p-mb-3" style="padding: 0.75rem;">
            <i class="pi pi-info-circle p-mr-2"></i>
            <span>Fetch records from a Gridly view in batches and write them to the {{ tableTitle }} table using the same logic as the migration job.</span>
          </div>
          <div class="p-field p-mb-3">
            <label for="migrateViewId" class="p-d-block p-mb-2">Gridly view ID</label>
            <input 
              id="migrateViewId"
              pInputText 
              type="text" 
              [(ngModel)]="migrateViewId"
              placeholder="e.g. abc123xyz"
              class="p-d-block"
              style="width: 100%;"
              [disabled]="migrateInProgress">
          </div>
          <div class="p-field p-mb-3">
            <label for="migrateBatchSize" class="p-d-block p-mb-2">Batch size</label>
            <input 
              id="migrateBatchSize"
              pInputNumber 
              [(ngModel)]="migrateBatchSize"
              [min]="1"
              [max]="500"
              [disabled]="migrateInProgress">
          </div>
          <div class="p-d-flex p-ai-center">
            <p-button 
              label="Migrate from Gridly" 
              icon="pi pi-cloud-download" 
              styleClass="p-button-sm"
              (click)="migrateTableFromGridly()"
              [disabled]="!migrateViewId?.trim() || migrateInProgress"
              [loading]="migrateInProgress">
            </p-button>
          </div>
          <div *ngIf="migrateResult" class="p-mt-3">
            <p-message 
              [severity]="migrateResult.success ? 'success' : 'warn'"
              [text]="migrateResult.success ? ('Migrated ' + (migrateResult.totalProcessed ?? 0) + ' records in ' + (migrateResult.batchesProcessed ?? 0) + ' batch(es).') : (migrateResult.errors && migrateResult.errors.length ? migrateResult.errors.join('; ') : 'Migration had errors')">
            </p-message>
          </div>
        </div>
      </p-panel>
    </div>
  </p-dialog>
  
  <p-table
    #locTable
    [value]="records"
    [paginator]="true"
    [rows]="rowsPerPage"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onLazyLoad)="onPageChange($event)"
    [responsive]="true"
    dataKey="rowKey"
    [(selection)]="selectedRecords"
    selectionMode="multiple"
    editMode="row"
    [loading]="loading"
    [first]="(currentPage - 1) * rowsPerPage"
    sortMode="single"
    [sortField]="sortBy"
    [sortOrder]="sortOrder === 'asc' ? 1 : -1"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pSortableColumn="recordId">
            Record ID
            <p-sortIcon field="recordId"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="recordId" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th *ngIf="!isSpecialTable" pSortableColumn="field">
            Field
            <p-sortIcon field="field"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="field" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th *ngIf="tableName === 'webadmin'" pSortableColumn="maxCharacterLength">
            Max character length
            <p-sortIcon field="maxCharacterLength"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="maxCharacterLength" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th pSortableColumn="Source_en">
            English (Source)
            <p-sortIcon field="Source_en"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="Source_en" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th pSortableColumn="Target_frFR">
            French (frFR)
            <p-sortIcon field="Target_frFR"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="Target_frFR" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th pSortableColumn="Target_esMx">
            Spanish (esMX)
            <p-sortIcon field="Target_esMx"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="Target_esMx" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th pSortableColumn="Target_deDE">
            German (deDE)
            <p-sortIcon field="Target_deDE"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="Target_deDE" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th pSortableColumn="updatedAt">
            Updated At
            <p-sortIcon field="updatedAt"></p-sortIcon>
            <p-columnFilter 
              type="text" 
              field="updatedAt" 
              display="menu"
              [showMatchModes]="true"
              [showOperator]="false"
              [matchModeOptions]="matchModeOptions">
            </p-columnFilter>
          </th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="record">
          <td>
            <p-tableCheckbox [value]="record"></p-tableCheckbox>
          </td>
          <td>{{ record.recordId }}</td>
          <td *ngIf="!isSpecialTable">{{ record.field }}</td>
          <td *ngIf="tableName === 'webadmin'">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="record.maxCharacterLength" style="width: 100%;">
              </ng-template>
              <ng-template pTemplate="output">
                {{ record.maxCharacterLength }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <textarea
                  pInputTextarea
                  [rows]="3"
                  [(ngModel)]="record.Source_en"
                  class="cell-textarea"
                  required
                  aria-required="true">
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                {{ record.Source_en }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <textarea pInputTextarea [rows]="3" [(ngModel)]="record.Target_frFR" class="cell-textarea"></textarea>
              </ng-template>
              <ng-template pTemplate="output">
                {{ record.Target_frFR }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <textarea pInputTextarea [rows]="3" [(ngModel)]="record.Target_esMx" class="cell-textarea"></textarea>
              </ng-template>
              <ng-template pTemplate="output">
                {{ record.Target_esMx }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <textarea pInputTextarea [rows]="3" [(ngModel)]="record.Target_deDE" class="cell-textarea"></textarea>
              </ng-template>
              <ng-template pTemplate="output">
                {{ record.Target_deDE }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>{{ record.updatedAt | date:'short' }}</td>
          <td>
            <div class="flex align-items-center justify-content-center gap-2">
              <button 
                *ngIf="!editing" 
                pButton 
                pRipple 
                type="button" 
                pInitEditableRow 
                icon="pi pi-pencil" 
                (click)="onRowEditInit(record)" 
                class="p-button-rounded p-button-text">
              </button>
              <button 
                *ngIf="!editing && !isSpecialTable" 
                pButton 
                pRipple 
                type="button" 
                icon="pi pi-language" 
                (click)="translateRecord(record)" 
                [disabled]="translatingRecords[getRowKey(record)]"
                [pTooltip]="'Retranslate this record using AI'"
                class="p-button-rounded p-button-text p-button-info">
              </button>
              <button 
                *ngIf="!editing" 
                pButton 
                pRipple 
                type="button" 
                icon="pi pi-trash" 
                (click)="deleteRecord(record)" 
                class="p-button-rounded p-button-text p-button-danger">
              </button>
              <button 
                *ngIf="editing" 
                pButton 
                pRipple 
                type="button" 
                icon="pi pi-check" 
                (click)="onRowEditSave(record, $event)" 
                class="p-button-rounded p-button-text p-button-success">
              </button>
              <button 
                *ngIf="editing" 
                pButton 
                pRipple 
                type="button" 
                pCancelEditableRow 
                icon="pi pi-times" 
                (click)="onRowEditCancel(record, ri)" 
                class="p-button-rounded p-button-text p-button-danger">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10" style="text-align: center; padding: 20px;">
            <p>No records found.</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
</div>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>


